<template>
    <div class="picture-check">
        <div class="picture-check_header">
            <div class="back-wrapper" @click="back">
                <img class="back-img" src="@/theme/images/knowledge/icon-arrow-back.svg">
                <span class="back-text">返回助手中心</span>
            </div>
            <span class="header-title">视觉大模型示例</span>
        </div>
        <div class="picture-check_content"
             element-loading-text="解析中，请稍后"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.55)"
             v-loading="loading">
            <div class="content-left">
                <div class="content-left_top">
                    <div class="operate-img-wrapper" ref="operateImgWrapper">
                        <div class="operate-img-box" ref="operateImgBox" v-show="curShowImg" @click="showBig">
                            <div class="operate-img-box_mask"></div>
                            <img ref="operateImgRef" class="operate-img"
                                 @load="loadImg"
                                 :style="{height: maxImgHeight}" :src="curShowImg" alt="预览图片">
                            <template v-for="(item, index) in rectList">
                                <div class="rect-box"
                                     :style="{
                                        'top': item.top,
                                        'left': item.left
                                     }"
                                     :key="index">
                                    <div class="rect-box_top" :style="{color: item.color}">
                                        <span class="rect-box_top-label">{{item.label}}</span>
                                        <span class="rect-box_top-score">{{item.score}}</span>
                                    </div>
                                    <div class="rect-box_down"
                                         :style="{
                                            'width': item.width,
                                            'height': item.height,
                                            'borderColor': item.color
                                    }"></div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="operate-btns-wrapper" :class="curShowImg ? '' : 'flex--empty'">
                        <div class="empty-wrapper flex--empty" v-if="!curShowImg">
                            <img src="@/theme/images/empty.png" alt="">
                            <span class="empty-text">暂未上传图片</span>
                        </div>
                        <input ref="upload" class="input-upload" type="file" accept="image/*" @change="uploadChange">
                        <el-button type="primary" @click="uploadImg">
                            <img src="@/theme/images/img.png" alt="">
                            <span class="btn-text">上传图片</span>
                        </el-button>
                        <el-button type="primary" v-show="curShowImg" @click="toCheckImg">
                            <img src="@/theme/images/rotate.png" alt="">
                            <span class="btn-text">验证效果</span>
                        </el-button>
                    </div>
                </div>
                <div class="content-left_down" v-show="curShowImg">
                    <div class="small-img-list" ref="smallImgListRef">
                        <template v-for="(img,index) in smallImgList">
                            <div :key="index" class="small-img-item"
                                 @click="changeShowImg(img, index)" :class="curShowImgIndex === index ? 'active-img-item' : ''">
                                <img class="small-img" :src="img" alt="">
                            </div>
                        </template>
                    </div>
                    <div class="scroll-operate-btns_left" @click="toScroll('left')">
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <div class="scroll-operate-btns_right" @click="toScroll('right')">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
            <div class="content-right">
                <div class="content-right_title">
                    <i class="el-icon-s-tools"></i>
                    <span class="title-text">参数配置</span>
                </div>
                <div class="content-right_form-item">
                    <div class="form-item-label is-require">选择模型:</div>
                    <div class="form-item-content">
                        <el-select v-model="model"
                                   :popper-append-to-body="false"
                                   placeholder="请选择" @change="modelChange">
                            <el-option
                                v-for="item in modelOptions"
                                :key="item.ID"
                                :label="item.Name"
                                :value="item.ID">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="content-right_form-item">
                    <div class="form-item-label">选择规则:</div>
                    <div class="form-item-content">
                        <el-radio-group v-model="rule">
                            <el-radio :label="2">按识别类型</el-radio>
                            <el-radio :label="1">按场景</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="content-right_form-item">
                    <div class="form-item-label is-require">识别{{rule === 2 ? '物品' : '场景'}}:</div>
                    <div class="form-item-content">
                        <el-select v-show="rule === 2" v-model="thingTypes"
                                   multiple clearable
                                   :popper-append-to-body="false"
                                   placeholder="请选择需要识别的物品">
                            <el-option
                                v-for="item in thingTypeOptions"
                                :key="item.typeId"
                                :label="item.typeName"
                                :value="item.typeId">
                                <div class="select-label-wrapper">
                                    <span class="select-label">{{ item.typeName }}</span>
                                    <div class="operate-icon">
                                        <i class="select-label_icon el-icon-circle-close"
                                           v-show="!item.isInner" @click.stop="deleteThing(item.typeId)"></i>
                                        <i v-show="thingTypes.indexOf(item.typeId) !== -1"
                                           class="select-label_icon el-icon-check"></i>
                                    </div>
                                </div>
                            </el-option>
                            <div class="add-thing-wrapper">
                                <el-input v-model.trim="thingInput" :maxlength="50" placeholder="请输入物品英文单词"/>
                                <el-link class="add-link" type="primary" icon="el-icon-plus" @click="addThing">新增类别</el-link>
                            </div>
                        </el-select>
                        <el-radio-group v-show="rule === 1" v-model="scene">
                            <template v-for="(item, index) in sceneItem">
                                <el-radio :label="index" :key="item.ID">{{item.TypeName}}</el-radio>
                            </template>
                        </el-radio-group>
                    </div>
                </div>
                <div class="scene-desc" v-show="rule === 1">备注：{{sceneItem[scene]['Desc']}}</div>
                <div class="content-right_form-item">
                    <div class="form-item-label">置信度:</div>
                    <div class="form-item-content">
                        <el-slider :show-input-controls="false" :min="0.00" :max="1.00" :step="0.01"
                                   v-model="trustNum" show-input></el-slider>
                    </div>
                </div>
            </div>
        </div>
        <div class="big-img-show" v-if="canvasImgShow">
            <i class="el-icon-circle-close big-img-show_close" @click="closeBigImg"></i>
            <div class="big-img-show_mask" @click="closeBigImg"></div>
            <img class="big-img" :src="canvasImg" alt="">
        </div>
        <CopyrightBar />
    </div>
</template>

<script>
import CopyrightBar from '@/app/components/ui/CopyrightBar.vue';
import { Colors, CvModels } from './PCI-Config';
import pictureDemoAPI from '@/api/pictureDemo.api.js';
import { uuid } from '../../../utils/uuid';
import { checkLocalImageShowable, getImageNatureSize, changeImgUrl } from '../../../utils/image';
import html2canvas from 'html2canvas';

export default {
    name: 'picture-check',
    components: { CopyrightBar },
    data () {
        return {
            loading: false,
            modelOptions: CvModels,
            model: 1,
            rule: 2,
            ruleBtns: [
                { label: '按识别类型', code: 2 },
                { label: '按场景', code: 1 }
            ],
            thingTypes: [],
            thingTypeOptions: [],
            thingInput: '',
            curModelItem: CvModels[0],
            sceneItem: CvModels[0]['Scenes'],
            scene: 0,
            trustNum: 0.6,
            smallImgList: [],
            curShowImg: '',
            canvasImg: '',
            curShowImgIndex: 0,
            rectList: [],
            maxImgHeight: '',
            imgResizeWidthNum: 1,
            imgResizeHeightNum: 1,
            canvasImgShow: false
        };
    },
    created () {
        this.getThings();
    },
    mounted () {
        this.init();
    },
    methods: {
        init () {
            this.getImgList();
            this.getMaxImgBoxHeight();
            window.addEventListener('resize', () => {
                this.getMaxImgBoxHeight();
                this.getImageNatureSize();
                this.rectList = [];
            });
        },
        async getImgList () {
            let ret = await pictureDemoAPI.getImgList(1, 8);
            if (ret.fail) {
                this.$message.warning(ret.msg);
                return;
            }
            let list = [];
            for (let i = 0; i < ret.data.length; i++) {
                list.push(changeImgUrl(ret.data[i]['picUrl']));
            }
            this.smallImgList = list;
            this.curShowImg = list[0] || '';
        },
        // 设置图片容器最大高度
        getMaxImgBoxHeight () {
            const contentStyle = this.$refs.operateImgWrapper.getBoundingClientRect();
            this.maxImgHeight = contentStyle.height + 'px';
        },
        // 获取物品类型
        async getThings () {
            let result = await pictureDemoAPI.getList();
            this.thingTypeOptions = result.data;
        },
        // 添加类目
        async addThing () {
            if (!this.thingInput) {
                this.$message.warning('请输入要新增的类别');
                return;
            }
            let ret = await pictureDemoAPI.addThing({
                typeName: this.thingInput
            });
            if (ret.fail) {
                this.$message.warning(ret.msg);
                return;
            } else {
                this.$message.success('新增类别成功');
                this.thingInput = '';
            }
            await this.getThings();
        },
        // 删除类目
        async deleteThing (typeId) {
            this.$confirmWarning('确定删除吗？').then(async () => {
                let ret = await pictureDemoAPI.deleteThing(typeId);
                if (ret.fail) {
                    this.$message.warning(ret.msg);
                    return;
                } else {
                    this.$message.success('删除类别成功');
                    this.removeSelectedTing(typeId);
                }
                await this.getThings();
            });
        },
        // 移除已选择类目
        removeSelectedTing (typeId) {
            this.thingTypes = this.thingTypes.filter((id) => {
                return typeId !== id;
            });
        },
        // 获取已选择类目名称
        getSelectedName () {
            let list = [];
            for (let i = 0; i < this.thingTypes.length; i++) {
                for (let j = 0; j < this.thingTypeOptions.length; j++) {
                    if (this.thingTypes[i] === this.thingTypeOptions[j]['typeId']) {
                        list.push(this.thingTypeOptions[j]['typeName']);
                    }
                }
            }
            return list;
        },
        // 返回知行助手
        back () {
            this.$emit('back');
        },
        // 模型变更
        modelChange (val) {
            this.curModelItem = this.modelOptions[val - 1];
            this.sceneItem = this.modelOptions[val - 1]['Scenes'];
        },
        // 打开上传图片窗口
        uploadImg () {
            const upload = this.$refs['upload'];
            upload.click();
        },
        // 上传图片变更
        async uploadChange () {
            const upload = this.$refs['upload'];
            const file = upload.files[0];
            if (file) {
                if (file.size / 1024 / 1024 / 50 > 1) {
                    this.$message.success('上传失败：图片大小最大50M');
                    return;
                }
                this.loading = true;
                // 检查图片是否可以展示
                let fileState = await checkLocalImageShowable(file);
                if (!fileState) {
                    this.$message.warning('上传失败：图片无法被加载，请更换图片');
                    this.loading = false;
                    return;
                }
                this.rectList = [];
                let res = await pictureDemoAPI.uploadImg(file);
                // 失败的话就把loading置false;
                if (res.fail) {
                    this.$message.warning(res.msg);
                    this.loading = false;
                    return;
                }
                this.$message.success('上传成功');
                let url = changeImgUrl(res.data);
                this.curShowImg = url;
                this.curShowImgIndex = 0;
                this.smallImgList.unshift(url);
                if (this.smallImgList.length > 8) {
                    this.smallImgList.length = 8;
                }
                upload.value = '';
                this.toScroll('left0');
                this.loading = false;
            }
        },
        // 监听图片加载完毕
        loadImg () {
            this.getImageNatureSize();
        },
        // 获取图片原始宽高
        async getImageNatureSize () {
            this.$nextTick(async () => {
                let operateImgRef = this.$refs.operateImgRef;
                let natureRect = await getImageNatureSize(operateImgRef);
                let style = operateImgRef.getBoundingClientRect();
                let rect = {
                    width: style.width,
                    height: style.height
                };
                // 获取图片容器和图片实际大小系数，用来定位框
                this.imgResizeWidthNum = rect.width / natureRect.width;
                this.imgResizeHeightNum = rect.height / natureRect.height;
            });
        },
        // 去验证
        async toCheckImg () {
            if (this.rule === 2 && !this.thingTypes.length) {
                this.$message.warning('参数配置--识别物品选项不能为空');
                return;
            }
            this.rectList = [];
            this.loading = true;
            let payload = {
                'uuid': uuid(), // 唯一id
                'image': location.origin + '/' + this.curShowImg, // 图片数据
                'imageType': 2, // 图片数据类型：1-base64格式，2-url格式
                'model': this.model, // 推理使用的模型ID值，按json配置文件中的约定值
                'detType': this.rule, // 检测类型：1-按场景；2-按类别；
                'thresh': this.trustNum // 置信度，取值范围[0,1]
            };
            // 类别专有参数
            if (this.rule === 2) {
                // 约定的类别检测字符列表，detType非2时可空
                payload.text = this.getSelectedName();
            } else {
                // 场景子项对应的类型，枚举值待约定，detType非1时传-1
                payload.textFeatureFileType = this.sceneItem[this.scene]['ID'];
            }
            let result = await pictureDemoAPI.handleImg(payload);
            this.loading = false;
            if (+result.code !== 0) {
                this.$message.error('推理接口异常：' + result.errMsg);
                return;
            }
            if (!result.data.result || !result.data.result.length) {
                this.$message.info('无可识别内容');
                return;
            }
            this.rectList = this.formatRect(result.data.result);
        },
        // 处理框选数据
        formatRect (result) {
            let list = [];
            let colorIndex = 0;
            for (let i = 0; i < result.length; i++) {
                list.push({
                    'color': Colors[colorIndex],
                    'top': result[i]['box'][1] * this.imgResizeHeightNum + 'px',
                    'left': result[i]['box'][0] * this.imgResizeWidthNum + 'px',
                    'width': (result[i]['box'][2] - result[i]['box'][0]) * this.imgResizeWidthNum + 'px',
                    'height': (result[i]['box'][3] - result[i]['box'][1]) * this.imgResizeHeightNum + 'px',
                    'label': result[i]['label'], // 目标标签
                    'box': result[i]['box'], // 目标矩形框位置，由矩形左上角x，y和右下角x，y组成的4个浮点型数值数组
                    'score': result[i]['score'].toFixed(2) // 目标置信度，取值[0,1]
                });
                if (colorIndex > 12) {
                    colorIndex = 0;
                } else {
                    colorIndex += 1;
                }
            }
            return list;
        },
        changeShowImg (img, index) {
            this.rectList = [];
            this.curShowImg = img;
            this.curShowImgIndex = index;
        },
        toScroll (type) {
            const smallImgListRef = this.$refs.smallImgListRef;
            if (type === 'left0') {
                smallImgListRef.scrollLeft = 0;
                return;
            }
            if (type === 'left') {
                if (smallImgListRef.scrollLeft !== 0) {
                    smallImgListRef.scrollLeft -= 100;
                    smallImgListRef.scrollLeft = smallImgListRef.scrollLeft <= 0 ? 0 : smallImgListRef.scrollLeft;
                }
            } else {
                if (smallImgListRef.scrollLeft >= smallImgListRef.scrollWidth) {
                    smallImgListRef.scrollLeft = smallImgListRef.scrollWidth;
                    return;
                }
                smallImgListRef.scrollLeft += 100;
            }
        },
        // 页面元素转图片
        toMakeImage (cb) {
            // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
            html2canvas(this.$refs.operateImgBox, {
                useCORS: true,
                scale: 2,
                backgroundColor: null // 避免图片有白色边框
            }).then((canvas) => {
                this.canvasImg = canvas.toDataURL('image/jpeg');
                cb && cb();
            });
        },
        showBig () {
            if (this.rectList.length) {
                this.loading = true;
                this.toMakeImage(() => {
                    this.canvasImgShow = true;
                    this.loading = false;
                });
            } else {
                this.canvasImg = this.curShowImg;
                this.canvasImgShow = true;
            }
        },
        closeBigImg () {
            this.canvasImgShow = false;
        }
    }
};
</script>

<style scoped lang="scss">
.picture-check {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    background-image: url('../../../theme/images/bg.png');
    background-size: cover;
    .picture-check_header {
        height: 64px;
        background-color: white;
        padding: 0 40px;
        display: flex;
        align-items: center;
        .back-wrapper {
            cursor: pointer;
            font-size: 16px;
            display: flex;
            align-items: center;
            margin-right: 16px;
            .back-img {
                width: 20px;
                height: 20px;
                margin-right: 4px;
            }
            .back-text {
                color: #126CFF;
            }
        }
        .header-title {
            font-size: 16px;
            color: rgba(7,22,51,0.85);
        }
    }
    .picture-check_content {
        width: 100%;
        height: 100%;
        overflow: hidden;
        padding: 40px;
        display: flex;
        position: relative;
        z-index: 0;
        .content-left {
            width: calc(100% - 496px);
            height: 100%;
            background-color: white;
            display: flex;
            flex-direction: column;
            .content-left_top {
                width: 100%;
                height: calc(100% - 160px);
                padding: 20px;
                padding-bottom: 0;
                position: relative;
                .operate-img-wrapper {
                    width: 100%;
                    height: calc(100% - 60px);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .operate-img-box {
                        position: relative;
                        .operate-img-box_mask {
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: 2;
                            width: 100%;
                            height: 100%;
                            cursor: pointer;
                        }
                        .rect-box {
                            position: absolute;
                            color: white;
                            .rect-box_top {
                                position: absolute;
                                top: -22px;
                                left: 0;
                                height: 24px;
                                display: flex;
                                align-items: center;
                                .rect-box_top-label {
                                    height: 22px;
                                    white-space: nowrap;
                                    line-height: 16px;
                                    padding: 2px;
                                }
                                .rect-box_top-score {
                                    padding: 4px;
                                    font-size: 12px;
                                }
                            }
                            .rect-box_down {
                                border: 2px solid;
                                box-sizing: border-box;
                            }
                        }
                    }
                    .operate-img {
                        max-width: 100%;
                        display: inline-block;
                    }
                }
                .operate-btns-wrapper {
                    width: 100%;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .el-button {
                        height: 28px;
                        width: 112px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: rgba(18, 108, 255, 1);
                        border-color: rgba(18, 108, 255, 1);
                        .btn-text {
                            line-height: 28px;
                            vertical-align: middle;
                        }
                        img {
                            margin-right: 6px;
                        }
                    }
                    .input-upload {
                        display: none;
                    }
                }
                .flex--empty {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    .empty-text {
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
                .operate-btns-wrapper.flex--empty {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -40%);
                }
                .empty-wrapper {
                    margin-bottom: 24px;
                }
            }
            .content-left_down {
                width: 100%;
                height: 160px;
                overflow: hidden;
                padding: 10px 24px 10px 72px;
                position: relative;
                .small-img-list {
                    width: 100%;
                    max-height: 160px;
                    overflow-y: hidden;
                    overflow-x: auto;
                    display: flex;
                    .small-img-item {
                        margin: 0 5px;
                        height: 124px;
                        cursor: pointer;
                        box-sizing: border-box;
                        .small-img {
                            max-width: 200px;
                            max-height: 120px;
                        }
                    }
                    .active-img-item {
                        border: 2px solid #126CFF;
                    }
                }
                .scroll-operate-btns_left, .scroll-operate-btns_right {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 2;
                    width: 40px;
                    height: 40px;
                    background-color: white;
                    border-radius: 50%;
                    overflow: hidden;
                    cursor: pointer;
                    box-shadow: 0px 2px 6px 0px rgba(7,22,51,0.2);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    font-weight: bolder;
                }
                .scroll-operate-btns_left {
                    left: 16px;
                }
                .scroll-operate-btns_right {
                    right: 16px;
                }
            }
        }
        .content-right {
            padding: 24px 18px;
            width: 480px;
            flex-shrink: 0;
            background-color: white;
            margin-left: 16px;
            .content-right_title {
                font-size: 16px;
                color: #36559F;
                margin-bottom: 32px;
                .title-text {
                    margin-left: 4px;
                }
            }
            .content-right_form-item {
                margin-bottom: 32px;
                display: flex;
                align-items: center;
                padding-left: 8px;
                .is-require:before {
                    content: '*';
                    color: red;
                }
                .form-item-label {
                    color: rgba(7, 22, 51, 0.65);
                    flex-shrink: 0;
                    width: 80px;
                    height: 40px;
                    line-height: 40px;
                    margin-right: 6px;
                    text-align: right;
                }
                .form-item-content {
                    width: 100%;
                    ::v-deep {
                        .el-select {
                            width: 100%;
                            .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
                                display: none;
                            }
                            .el-select-dropdown.is-multiple .el-select-dropdown__item {
                                padding-right: 12px;
                            }
                        }
                        .select-label-wrapper {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .select-label {}
                            .select-label_close {
                                color: black;
                            }
                            .operate-icon {
                                width: 50px;
                                .el-icon-check {
                                    font-weight: bolder;
                                    color: #3B77FF;
                                }
                                .el-icon-circle-close {
                                    margin-right: 14px;
                                    color: black;
                                }
                            }
                        }
                        .el-select-dropdown__list {
                            padding-bottom: 100px;
                        }
                        .el-slider__input {
                            width: 60px;
                        }
                        .el-slider__runway {
                            background-color: rgba(18, 108, 255, 0.15);
                        }
                        .el-slider__runway.show-input {
                            margin-right: 80px;
                        }
                        .el-slider, .el-radio-group {
                            padding-top: 4px;
                        }
                        .el-radio__label {
                            position: relative;
                            top: 1px;
                            color: rgba(7, 22, 51, 1);
                        }
                        .el-slider__bar, .el-radio__input.is-checked .el-radio__inner {
                            background-color: rgba(18, 108, 255, 1);
                        }
                    }
                    .add-thing-wrapper {
                        padding: 24px;
                        position: absolute;
                        z-index: 2;
                        bottom: 0;
                        background: white;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        .add-link {
                            flex-shrink: 0;
                            margin-left: 16px;
                        }
                    }
                }
            }
            .scene-desc {
                width: 100%;
                font-size: 12px;
                margin-bottom: 40px;
                margin-top: -30px;
                padding-left: 94px;
                color: rgba(7, 22, 51, 0.65);
            }
        }
    }
    .CopyrightBar {
        position: absolute;
        bottom: 4px;
        left: 50%;
        transform: translateX(-50%);
    }
    .big-img-show {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .big-img-show_close {
            position: absolute;
            top: 40px;
            right: 40px;
            font-size: 40px;
            cursor: pointer;
            z-index: 2;
            color: rgba(255,255,255,0.65);
        }
        .big-img-show_mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
            background-color: rgba(0,0,0,0.85);
        }
        .big-img {
            height: 90%;
            position: relative;
            z-index: 2;
        }
    }
}
</style>
